export * from '@lux/core';
/**
 * @deprecated Use FunctionColor or BrandColor instead. This will be deleted in next version
 */
export var Color;
(function (Color) {
    Color["brand"] = "var(--brand-color--lounge)";
    Color["primary"] = "var(--brand-color--primary)";
    Color["dark"] = "var(--function-color--function100)";
    Color["bright"] = "var(--function-color--function0)";
})(Color || (Color = {}));
/**
 * @deprecated Use FunctionColor instead. This will be deleted in next version
 */
export var ShadeColor;
(function (ShadeColor) {
    ShadeColor["dark80"] = "var(--function-color--function80)";
    ShadeColor["dark60"] = "var(--function-color--function60)";
    ShadeColor["dark40"] = "var(--function-color--function40)";
    ShadeColor["dark20"] = "var(--function-color--function20)";
    ShadeColor["dark10"] = "var(--function-color--function10)";
})(ShadeColor || (ShadeColor = {}));
//# sourceMappingURL=index.js.map